import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Hour } from '@nu-art/ts-common';
export const ApiDef_ICDMapping = {
    _v1: {
        mapChapter: { method: HttpMethod.POST, path: '/v1/icd-mapping/map-chapter', timeout: Hour }, // long timeout is required due heavy action
    }
};
//# sourceMappingURL=api-def.js.map